var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHistorialPagos = function SvgHistorialPagos(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "historial_pagos_svg__Capa_2",
    viewBox: "0 0 61.17 53.63"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "historial_pagos_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.62,
    height: 39.29,
    x: 14.55,
    rx: 3.97,
    ry: 3.97,
    fill: "#f1dffb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.26 18.09H31.79c-.99 0-1.96-.31-2.77-.89l-4.44-3.19a4.76 4.76 0 0 0-2.77-.89H4.76C2.13 13.12 0 15.25 0 17.88v31.01c0 2.63 2.13 4.76 4.76 4.76h47.96c2.93 0 5.3-2.37 5.3-5.3V22.86c0-2.63-2.13-4.76-4.76-4.76Z",
    fill: "#e1baf7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2 23.86h3.59c.16 0 .3.06.41.17s.17.25.17.42v.66c0 .16.06.31.17.45s.25.23.41.25c1.39.36 2.71 1.04 3.95 2.04.13.09.2.23.22.39s-.02.31-.12.44l-1.89 2.7q-.135.195-.39.24c-.16.03-.31 0-.44-.1-.82-.52-1.59-.89-2.3-1.1-.71-.22-1.37-.33-1.97-.33-.18 0-.38 0-.62.01-.23.01-.46.04-.67.1-.21.05-.38.15-.52.28s-.21.31-.21.53.17.43.51.61.73.33 1.17.46q.66.195 1.26.3c.4.07.66.12.78.14.58.11 1.22.28 1.92.5.69.22 1.34.55 1.95.97q.915.645 1.53 1.68c.41.69.62 1.55.62 2.59 0 1.59-.43 2.82-1.3 3.7-.86.88-2.02 1.44-3.48 1.7-.16.03-.3.11-.41.24s-.17.27-.17.44v.71c0 .16-.06.3-.17.42-.11.11-.25.17-.41.17H26.2c-.16 0-.3-.06-.41-.17a.57.57 0 0 1-.17-.42v-1c0-.16-.05-.31-.15-.46a.76.76 0 0 0-.4-.29q-1.17-.345-2.13-.9c-.65-.37-1.24-.78-1.77-1.22a.64.64 0 0 1-.22-.43q-.03-.255.12-.45l1.86-2.7c.09-.13.22-.21.38-.24s.31 0 .44.07c.87.57 1.73 1.02 2.59 1.34.86.33 1.66.49 2.4.49s1.25-.1 1.62-.3.56-.5.56-.91c0-.21-.08-.37-.24-.5-.16-.12-.38-.23-.65-.3-.27-.08-.58-.15-.94-.2s-.72-.11-1.09-.2c-.36-.07-.77-.14-1.25-.23s-.96-.22-1.47-.39c-.5-.17-1-.39-1.49-.65s-.94-.59-1.32-1c-.38-.4-.7-.88-.94-1.45-.24-.56-.35-1.22-.35-1.98s.1-1.41.3-1.98c.2-.58.48-1.07.83-1.51.36-.43.76-.78 1.23-1.06.46-.28.96-.51 1.49-.68.16-.05.3-.14.4-.28.11-.14.15-.29.15-.45v-.75c0-.16.06-.3.17-.42a.53.53 0 0 1 .41-.17Z",
    fill: "#7f15bc"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.44,
    cy: 7.86,
    r: 1.85,
    fill: "#7f15bc"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.68,
    height: 3.7,
    x: 27.29,
    y: 6.01,
    rx: 1.85,
    ry: 1.85,
    fill: "#7f15bc"
  }))));
};
export default SvgHistorialPagos;